import Alert from '@eversports/klimt-primitives/legacy/Alert'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../localization/react'

interface Props {
  isPayAtVenueAllowed: boolean
}

function PrivateSessionBookingRequestAlert({ isPayAtVenueAllowed }: Props) {
  if (isPayAtVenueAllowed) {
    return (
      <Alert severity="info" sx={{ my: 1 }}>
        <Text variant="large">
          <Localized id="private-session-booking-request-product-selection-title" />
        </Text>
        <Text>
          <Localized id="private-session-booking-request-product-selection-description" />
        </Text>
      </Alert>
    )
  }

  return (
    <Alert severity="warning" sx={{ my: 1 }}>
      <Text variant="large">
        <Localized id="private-session-booking-request-product-selection-title-payment-required" />
      </Text>
      <Text>
        <Localized id="private-session-booking-request-product-selection-description-payment-required" />
      </Text>
    </Alert>
  )
}

export { PrivateSessionBookingRequestAlert }
